import { CSSProperties } from 'react';
import { colors } from '../../styles/colors';

export const styles = {
    storyTitle: {
        fontSize: 25,
        width: '100%',
        marginBottom: 10,
    },
    relative: {
        position: 'relative',
    } as CSSProperties,
    iconLink: {
        position: 'absolute',
        right: -50,
        top: 35,
    } as CSSProperties,
    buttonRowContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    } as CSSProperties,
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        position: 'relative',
        pointerEvents: 'auto',
    } as React.CSSProperties,
    headerContainer: {
        height: '10%',
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: 26,
        color: 'black',
        marginBottom: 35,
        fontWeight: 'bolder',
    } as React.CSSProperties,
    buttonText: {
        fontSize: 16,
    },
    button: {
        height: 55,
        width: 200,
    },
    subText: {
        fontSize: 14,
        fontStyle: 'italic',
        opacity: 0.8,
        marginBottom: 15,
        paddingRight: 5,
    } as React.CSSProperties,
    actionText: {
        fontSize: 22,
        color: 'black',
        marginBottom: 7,
        paddingRight: 5,
    },
    uploadIcon: {
        height: 80,
        width: 80,
        objectFit: 'contain',
        marginBottom: 20,
    } as React.CSSProperties,
    uploadContainer: {
        flex: 1,
        width: '70%',
        marginBottom: '7%',
        border: '2px dashed #3D8BA2',
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    } as React.CSSProperties,
    innerDropZone: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    } as React.CSSProperties,
    inputContainer: { width: '100%', height: 85, backgroundColor: 'white' },
    input: (shouldDisable: boolean) => {
        return {
            position: 'relative',
            width: '100%',
            height: 85,
            borderRadius: 5,
            boxShadow: '0px 10px 35px rgba(0, 0, 0, 0.08)',
            marginBottom: 25,
            opacity: shouldDisable ? 0.5 : 1,
        } as CSSProperties;
    },
    inputCancel: {
        cursor: 'pointer',
        height: 30,
        width: 30,
        borderRadius: 15,
        position: 'relative',
        right: '-89%',
        bottom: 72,
        backgroundColor: '#00000022',
    } as CSSProperties,
    cancelIcon: {
        height: '100%',
        width: '100%',
        objectFit: 'contain',
    } as React.CSSProperties,
    addPhotosHeaderText: {
        height: 120,
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        fontSize: 26,
        color: 'black',
        fontWeight: 'bolder',
    } as CSSProperties,
    addPhotosHeader: {
        display: 'flex',
        flex: 1,
        alignSelf: 'stretch',
        flexDirection: 'column',
    } as CSSProperties,
    addPhotosLeft: {
        display: 'flex',
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: 20,
        flexDirection: 'column',
        position: 'relative',
    } as CSSProperties,
    addPhotosContainer: {
        display: 'flex',
        alignSelf: 'stretch',
        flex: 1,
    } as CSSProperties,
    addPhotosUploader: {
        height: '70%',
        width: '80%',
        border: '2px dashed #3D8BA2',
        borderRadius: 5,
        borderBottom: 'none',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        overflowY: 'scroll',
    } as CSSProperties,
    addPhotosRight: {
        display: 'flex',
        flex: 1,
        alignSelf: 'stretch',
        paddingLeft: 20,
        alignItems: 'center',
    } as CSSProperties,
    addPhotosInputsContainer: {
        height: '90%',
        width: '80%',
        borderRadius: 5,
    },
    actionButtonBar: {
        paddingRight: 35,
    },
    uploadedImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        borderRadius: 5,
    } as CSSProperties,
    imageContainer: {
        width: '23%',
        paddingTop: '23%',
        margin: '1%',
        position: 'relative',
        borderWidth: 3,
        borderStyle: 'solid',
        borderColor: 'transparent',
        overflow: 'hidden',
    } as CSSProperties,
    selectedImageContainer: {
        borderColor: colors.ORANGE,
        borderRadius: 8,
    },
    wrapContainer: {
        display: 'flex',
        flex: 1,
        width: '100%',
        flexWrap: 'wrap',
        maxHeight: '50vh',
    } as CSSProperties,
    chooseFilesButton: {
        height: 40,
        width: 120,
        marginTop: 9,
    },
    deleteButton: {
        height: 55,
        width: 175,
        backgroundColor: colors.CANCEL_TEXT,
        color: 'white',
    },
    smallFont: {
        fontSize: 14,
    },
    uploadSubText: {
        fontStyle: 'italic',
        fontSize: 14,
        opacity: 0.8,
        paddingRight: 5,
    } as CSSProperties,
    dropPhotoText: {
        fontSize: 18,
    },
    dropPhotoTextContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        paddingLeft: 15,
        paddingTop: 12,
    } as CSSProperties,
    uploadPhotoIcon: {
        height: 60,
        width: 60,
        objectFit: 'contain',
    } as React.CSSProperties,
    additionalUploadContainer: {
        height: '20%',
        width: '80%',
        marginBottom: '5%',
        border: '2px dashed #3D8BA2',
        borderRadius: 5,
        borderTop: 'none',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingRight: 20,
        paddingLeft: 20,
        flex: 1,
    } as CSSProperties,
    wideUploadContainer: {
        flex: 1,
        border: '2px dashed #3D8BA2',
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '93%',
        marginBottom: '3%',
    } as React.CSSProperties,
    paddedContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingTop: 20,
    } as React.CSSProperties,
    paddedHeader: {
        height: '100%',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        fontSize: 26,
        color: 'black',
        fontWeight: 'bolder',
        paddingTop: 20,
    } as CSSProperties,
    rotateAndRemoveContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    } as CSSProperties,
    uploadingPhotosText: {
        fontSize: 30,
        color: 'black',
        textAlign: 'center',
        width: '100%',
    } as React.CSSProperties,
    uploadingPhotosCount: {
        fontSize: 24,
        color: 'black',
        textAlign: 'center',
        width: '100%',
    } as React.CSSProperties,
    uploadingPhotosContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: '#FFFFFFCC',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    } as CSSProperties,
};



// WEBPACK FOOTER //
// ./src/Pages/PhotosPage/AddPhotosStyle.tsx